import { useEffect } from 'react';
import { InitKakao } from './index';
export var KakaoScripts = function () {
    useEffect(function () {
        var script = document.createElement('script');
        script.src = 'https://t1.kakaocdn.net/kakao_js_sdk/2.0.0/kakao.min.js';
        script.integrity = 'sha384-PFHeU/4gvSH8kpvhrigAPfZGBDPs372JceJq3jAXce11bVA6rMvGWzvP4fMQuBGL';
        script.crossOrigin = 'anonymous';
        script.onload = InitKakao;
        document.body.appendChild(script);
    }, []);
    return null;
};
//# sourceMappingURL=scripts.js.map